import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/our-chat/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_parcheesi banner_chat text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/our-chat/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={163}
                height={153}
              />
            </div>
            <p>
              OurChat is a paid texting service that connects you with a range
              of professionals at your fingertips. It is a mobile and web app
              that was especially designed to offer a simple and convenient way
              for users to communicate with professionals and get the help they
              need, all at a reasonable price. Our unique token system ensures
              that you only pay for the messages you send, making it an
              affordable option for everyone.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/ca/app/ourchat-inc/id6444663778">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.ourchat&hl=en_US">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/our-chat/banner-girl.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={657}
                height={759}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
